@if (status) {
  <div class="trend-container">
    @if (styleType === 'extended') {
      <img [src]="'/public/assets/images/' + status + '.svg'" [alt]="status + ' icon'" />
      <p>{{ 'trend.' + status | translate }}</p>
    } @else {
      <img [src]="'/public/assets/images/compact_' + status + '.svg'" [alt]="status + ' icon'" class="compact-icon" />
    }
  </div>
}

